import MainLayout from "@/components/layout/admin/MainLayout.vue";
import AdvancedLaravelVuePaginate from 'advanced-laravel-vue-paginate';
import 'advanced-laravel-vue-paginate/dist/advanced-laravel-vue-paginate.css';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import CONFIG from "@/assets/js/config.js";
import axios from "axios";

export default {
  name: "GradeList",
  components: {
    MainLayout,
    AdvancedLaravelVuePaginate,
    Loading
  },

  data() {
    return {
      isFilterOpen: false,
      noDataMsg: CONFIG.NO_DATA_FOUND,
      isLoading: false,
      search_grade_name: null,
      searchedData: null,
      isSearched: false,
      gradeData: {},
      templateLink: '',
      gradeFile: '',
      gradeFileName: '',
      invalidFileType: false,
      disabled: false,
      submitted: false,
    };
  },

  methods: {
    getGrade(page = 1) {
      axios.get('grade/list?page=' + page)
        .then(res => {
          this.gradeData = res.data;
          this.isLoading = false;
        }).catch((error) => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
        });
    },

    reset() {
      this.search_grade_name = null;
      this.isLoading = true;
      this.getGrade();
      this.isSearched = false;
    },

    search(page = 1) {
      this.isLoading = true;
      this.searchedData = { grade_name: this.search_grade_name };
      this.isSearched = true;
      axios.get('grade/search?page=' + page, {
        params: {
          grade_name: this.search_grade_name
        }
      })
        .then((res) => {
          this.gradeData = res.data;
          this.isLoading = false;
        }).catch((error) => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
        });
    },

    excelDownload() {
      this.isLoading = true;
      const params = this.isSearched && this.searchedData
        ? { ...this.searchedData }
        : {};
      axios.get('/grade/excelDownload', {
        params,
        responseType: 'arraybuffer'
      })
        .then(response => {
          this.isLoading = false;
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement('a');
          fileLink.href = fileURL;
          let date = new Date();
          fileLink.setAttribute('download', `grade_list_${date.getFullYear()}${(date.getMonth() + 1) < 9 ? 0 : ''}${(date.getMonth() + 1)}${date.getDate() < 9 ? 0 : ''}${date.getDate()}.xlsx`);
          document.body.appendChild(fileLink);
          fileLink.click();
        }).catch(error => {
          if (error.response && error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
        });
    },

    getTemplateLink() {
      axios.get('grade/getTemplateLink')
        .then(res => {
          this.templateLink = res.data;
        }).catch((error) => {
          if (error.response && error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
        });
    },

    chooseFile() {
      this.$refs.fileUploader.value = '';
      document.getElementById('grade-upload').click();
    },

    onGradeFileChange() {
      this.invalidFileType = false;
      let selectedFile = document.getElementById('grade-upload').files;
      if (selectedFile.length) {
        let file = selectedFile[0];
        if (file.type == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
          this.gradeFileName = file.name;
          this.gradeFile = file;
        } else {
          this.invalidFileType = true;
        }
      }
      this.disabled = false;
    },

    clearFile() {
      this.gradeFile = '';
      this.gradeFileName = '';
      this.invalidFileType = false;
      this.disabled = false;
      this.submitted = false;
      if (this.$refs.fileUploader) {
        this.$refs.fileUploader.value = '';
      }
    },

    importFile() {
      this.submitted = true;

      if (!this.gradeFile) {
        return;
      }

      this.disabled = true;
      this.isLoading = true;
      let data = new FormData();
      data.append('grade_xlsx', this.gradeFile);

      axios.post("grade/import", data, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }).then(response => {
        this.isLoading = false;
        this.disabled = false;
        if (response.data.success == true) {
          this.$notification.success(response.data.msg, {
            timer: 3,
            position: "bottomCenter"
          });
          this.clearFile();
          this.getGrade();
        } else {
          this.clearFile();
          alert(response.data.msg);
        }
      }).catch(error => {
        this.isLoading = false;
        this.disabled = false;
        if (error.response && error.response.status == 401) {
          this.$store.commit('logout');
          window.location.replace('login');
        }
        console.error('Error in import grade:', error);
      });
    },
  },

  mounted() {
    this.isLoading = true;
    this.getGrade();
    this.getTemplateLink();
  },
};
